let closeModalCustomer = function() {
    this.itemNameCustomers = [];
    this.$store.commit("core/setCloseModal", {});
    // this.$modal.hide("nameCustomer");
};
export default closeModalCustomer;
